"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomController = void 0;
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const logger_1 = require("../../util/logger");
const participant_filter_provider_1 = require("../../util/rx/participant_filter_provider");
const last_created_at_1 = require("../../util/rx/last_created_at");
const utils_1 = require("../wall/utils");
class RoomController {
    constructor(config) {
        var _a;
        this.config = config;
        this.room = this.config.roomWall.itemsById.pipe((0, utils_1.findInGroup)(this.config.context.roomId.toString()), (0, utils_1.mapWallItemFromWallItemEvents)('room'));
        this.roomStatus = this.room.pipe((0, operators_1.map)(room => { var _a; return (_a = room === null || room === void 0 ? void 0 : room.status) !== null && _a !== void 0 ? _a : undefined; }));
        this.participantUpdates = this.room.pipe((0, operators_1.mergeMap)(room => { var _a; return (_a = room === null || room === void 0 ? void 0 : room.participants) !== null && _a !== void 0 ? _a : []; }));
        this.localParticipant = this.participantUpdates.pipe((0, participant_filter_provider_1.participantFilterProvider)(this.config.context.localUserId));
        this.localParticipantStatus = this.localParticipant.pipe((0, operators_1.map)(p => p.status || undefined));
        this.remoteParticipant = this.participantUpdates.pipe((0, participant_filter_provider_1.participantFilterProvider)(this.config.context.remoteUserId));
        this.remoteParticipantStatus = this.remoteParticipant.pipe((0, operators_1.map)(p => p.status || undefined));
        this.remoteParticipantCapabilities = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('capabilities'), (0, utils_1.accumulateAndMapWallEvents)('capabilities'), (0, utils_1.filterByProperty)('ownerUserId', (_a = this.config.context.remoteUserId) === null || _a === void 0 ? void 0 : _a.toString()), (0, last_created_at_1.lastCreatedAt)());
        this.onsite = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('roomInvitation'), (0, utils_1.accumulateAndMapWallEvents)('roomInvitation'), (0, operators_1.map)(invitations => invitations.length === 0), (0, operators_1.startWith)(true), (0, operators_1.shareReplay)(1));
    }
    leaveRoom() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.localUserId, 'Expected localUserId to be defined when leaving room');
            try {
                yield api_1.StreemAPI.rooms.leaveRoom(this.config.context.roomId.toString(), this.config.context.localUserId.toString());
                logger_1.logger.info(`User ${this.config.context.localUserId} has left room ${this.config.context.roomId}`);
            }
            catch (e) {
                if (e.status === 304) {
                    logger_1.logger.info(`${this.config.context.localUserId} has already left the room. Ignoring API request to leave`);
                }
                else {
                    logger_1.logger.error(`${this.config.context.localUserId} failed to leave room ${this.config.context.roomId}.`, e);
                }
            }
        });
    }
    sendClientCapabilities(canSendCameraSubjects) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.callSettings, 'Call settings must be defined to send client capabilities');
            const capabilities = {
                canReceiveCompressedDataTrackMessages: true,
                canReceiveNonUprightCameraImages: false,
                sendsArScanningRequests: true,
                canReceiveVideo: true,
                canSendCameraSubjects,
            };
            logger_1.logger.info(` ${this.config.context.localUserId} has sent their capabilities`, capabilities);
            this.config.roomWall.addCapabilities(capabilities);
        });
    }
}
exports.RoomController = RoomController;
//# sourceMappingURL=room_controller.js.map